'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var icon = require('./icon.js');
var space = require('./space.js');
var useDidUpdate = require('../hooks/useDidUpdate.js');
var text = require('./text.js');
var themeGet = require('../utils/themeGet.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  user-select: none;\n  margin-top: -1px;\n  color: ", ";\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  align-items: center;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = styled__default['default'](space['default'])(_templateObject(), index.styleEngine);
var StyledIcon = styled__default['default'](icon['default'])(_templateObject2(), index.styleEngine);
var Label = styled__default['default'](text['default'])(_templateObject3(), themeGet['default']('colors.grey.12'), index.styleEngine);

var Checkbox = function Checkbox(_ref) {
  var propChecked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      label = _ref.label,
      labelProps = _ref.labelProps,
      wrapperProps = _ref.wrapperProps,
      restProps = _objectWithoutProperties(_ref, ["checked", "disabled", "onChange", "label", "labelProps", "wrapperProps"]);

  var _useState = React.useState(propChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  useDidUpdate['default'](function () {
    onChange && onChange(checked);
  }, [checked]);
  React.useEffect(function () {
    setChecked(propChecked);
  }, [propChecked]);
  return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? '0.5' : '1',
    onClick: function onClick() {
      return !disabled && setChecked(!checked);
    },
    itemProps: {
      height: '100%'
    },
    gutter: 8
  }, wrapperProps), /*#__PURE__*/React__default['default'].createElement(StyledIcon, _extends({
    icon: checked ? 'pyt-check_box_active-16' : 'pyt-check_box_blank-16',
    color: checked ? 'primary' : 'rgba(0, 0, 0, 0.3)'
  }, restProps)), label ? /*#__PURE__*/React__default['default'].createElement(Label, labelProps, label) : null);
};

Checkbox.propTypes = {
  onChange: PropTypes__default['default'].func,
  disabled: PropTypes__default['default'].bool,
  checked: PropTypes__default['default'].bool,
  label: PropTypes__default['default'].node,
  labelProps: PropTypes__default['default'].object
};

exports.default = Checkbox;
